import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../../components/panel/panel";
import OrdersVialBillingTable from "./ordersVialBillingTable.js";

function OrdersVialBilling() {
  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item active">
              Facturación Varo Express
            </li>
          </ol>
          <h1 className="page-header mb-0">Facturación Varo Express</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader noButton>Órdenes viales</PanelHeader>
            <PanelBody>
              <OrdersVialBillingTable />
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default OrdersVialBilling;
